export const getHandbooksListPath = (companyId: string) => {
  return `/companies/${companyId}/handbooks`;
};

export const handbooksResourceType = "handbook_item" as const;
